import { useTheme } from '@mui/material/styles';


import {
  Grid,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import Page from '../components/Page';
import {
  AppWidgetSummary,
} from '../sections/@dashboard/app';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { GetUserVendorListAction, GetVendorDetailAction } from '../redux/actions/UsersAction'; // Import the correct action
import { GetDashboardVendorDetails } from 'src/redux/actions/DashboardAction';

export default function DashboardVendorApp() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const dashboardSelector = useSelector((state) => state.dashboard.dashboard_list);
  const dashboardData = dashboardSelector?.data || {};

  // Fetch the user list 
  const UserList = useSelector((state) => state?.users.uservendor_list?.data);
  const USERLIST = UserList && UserList?.data?.users;
  

  const loadingUserList = useSelector((state) => state.users.loading); 

  const [selectedVendor, setSelectedVendor] = useState('all');
  const [state, setState] = useState({
      userList: [],
      v: {},
    });

    

  useEffect(() => {
    // Fetch dashboard data and user vendor data on component mount or vendor change
    console.log("selectedVendor--->>",selectedVendor);
    dispatch(GetUserVendorListAction(selectedVendor)); // Dispatch action to fetch users based on selected vendor
  }, []);



  // useEffect(() => {
  //   console.log("selectedVendorDetail--->>",selectedVendor);
  //     //dispatch(GetVendorDetailAction(selectedVendor ));
  //   }
  //  ,[selectedVendor]);

  
  
  useEffect(() => {
    if (selectedVendor !== 'all') {
      dispatch(GetDashboardVendorDetails(selectedVendor)); // Dispatch action to get new dashboard data based on selected vendor
    }
  }, [dispatch, selectedVendor]);
  
  useEffect(() => {
      console.log("UserData--->>",UserList )
  
      if (UserList) {
        setState({ ...state, userList: UserList?.data?.users });
      }
    }, [UserList, dispatch]);

  

  const handleVendorChange = (event) => {
    console.log("event.target.value--->>",event.target.value);
    
    setSelectedVendor(event.target.value);
  };

  return (
    <Page title="Dashboard 2">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Hi, Welcome back
        </Typography>

        <FormControl sx={{ minWidth: 240, mb: 2 }} size="small">
          <InputLabel _id="vendor-select-label">Select Vendor</InputLabel>
          <Select
            labelId="vendor-select-label"
            _id="vendor-select"
            value={selectedVendor}
            label="Select Vendor"
            onChange={handleVendorChange}
          >
            
            {USERLIST?.map((vendor) => (
              <MenuItem key={vendor._id} value={vendor._id}>
                {vendor.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Registrations"
              total={dashboardData?.total_registrations_count || 0}
              color="error"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Active User"
              total={dashboardData?.active_user_count || 0}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Today Signup User"
              total={dashboardData?.signup_count || 0}
              color="info"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Created Contest"
              total={dashboardData?.create_contest_count || 0}
              color="warning"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Active Contest"
              total={dashboardData?.active_contest_count || 0}
              color="error"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Inactive Contest"
              total={dashboardData?.inactive_contest_count || 0}
              color="warning"
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}